export default __webpack_public_path__ + "static/media/eyeIcon.6321ed6d.svg";